import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { paths } from '@constants/paths';
import { APPOINTMENT_ID } from '@constants/storageKeys';
import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { useDetailsContext } from '@providers/basket/DetailsProvider/Context';
import { clearFormPersistStorage } from '@utils/storagePropertyManagement';

// Check appointment ID from local storage in case a partner manually changes the browser URL
const getAppointmentId = () => localStorage.getItem(APPOINTMENT_ID);

const useClearSubmittedBasketContext = () => {
  const { basketId, basketGuardData, handleStartAgain, applicationSubmitting } =
    useBasketContext();
  const { endAppointment } = useAppointmentContext();

  const { resetDetails } = useDetailsContext();
  const location = useLocation();

  const isThankYouPage = location.pathname === paths.thankYou;
  const basketSubmittedAt = basketGuardData?.basket?.details?.submittedAt;
  const appointmentId = getAppointmentId();

  useEffect(() => {
    if (
      !basketId ||
      !basketSubmittedAt ||
      applicationSubmitting ||
      isThankYouPage
    ) {
      return;
    }

    if (appointmentId) {
      endAppointment();
      return;
    }

    resetDetails();
    clearFormPersistStorage();
    handleStartAgain();
  }, [
    resetDetails,
    handleStartAgain,
    isThankYouPage,
    basketId,
    basketSubmittedAt,
    endAppointment,
    appointmentId,
    applicationSubmitting,
  ]);
};

export { useClearSubmittedBasketContext };
